export function calculateAvatarAbbreviation(string = '') {
  const startingLetters = string.split(' ').map(word => word.trim()[0]?.toUpperCase()).filter(Boolean);
  if (startingLetters.length === 0) {
    return '';
  }
  return `${startingLetters[0]}${startingLetters.length > 1 ? startingLetters.at(-1) : ''}`;
}